$(document).ready(function() {
  var nextPrevProduct = $('.next-previous-buttons-product-page'),
  iconNextPrev = nextPrevProduct.find('[data-next-prev-icon]'),
  contentNextPrev = nextPrevProduct.find('[data-next-prev-content]'),
  modal = nextPrevProduct.find('[data-next-prev-modal]');
  console.log(nextPrevProduct);
  if(!('ontouchstart' in document)) {
    iconNextPrev.hover(function() {
      var curLink = $(this),
      curContent = $(curLink.data('target'));
      console.log(curContent);
      if(!$(this).hasClass('active')) {
        iconNextPrev.removeClass('active');
        contentNextPrev.removeClass('active');
        
        curLink.addClass('active');
        curContent.addClass('active');
        modal.show();
      }
      nextPrevProduct.mouseleave(function() {
        if(modal.is(':visible')) {
          iconNextPrev.removeClass('active');
          contentNextPrev.removeClass('active');
          modal.hide();
        };
      });
    });
  } else {
    iconNextPrev.off('click').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var curLink = $(this),
      curContent = $(curLink.data('target'));
      
      if(!$(this).hasClass('active')) {
        iconNextPrev.removeClass('active');
        contentNextPrev.removeClass('active');
        
        curLink.addClass('active');
        curContent.addClass('active');
        modal.show();
      } else {
        curLink.removeClass('active');
        curContent.removeClass('active');
        modal.hide();
      }
    });
  };
  
  $(document).on('click', function(e) {
    if(!$(e.target).closest('[data-next-prev-modal]').length && modal.is(':visible')) {
      iconNextPrev.removeClass('active');
      contentNextPrev.removeClass('active');
      modal.hide();
    };
  });
});